import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

// items: [{ label, to?, icon? }] — último é o ativo sem link.
const Breadcrumb = ({ items = [], className = '' }) => {
  if (!items.length) return null;
  return (
    <nav aria-label="Breadcrumb" className={className}>
      <ol className="flex items-center flex-wrap gap-1.5 text-sm text-app-text-secondary">
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <li key={idx} className="inline-flex items-center gap-1.5">
              {idx > 0 && <ChevronRight size={14} className="text-app-text-secondary/70" />}
              {isLast || !item.to ? (
                <span className={isLast ? 'text-app-text font-medium' : ''} aria-current={isLast ? 'page' : undefined}>
                  {item.icon}
                  {item.label}
                </span>
              ) : (
                <Link to={item.to} className="hover:text-primary transition-colors inline-flex items-center gap-1">
                  {item.icon}
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
